<template>
    <div class="basic-image-container">
        <star-condition-layout :onSearch="handleSearch" :onReset="reset" :loading="loading">
            <star-condition-cell label="数据库名称">
                <a-input v-model="searchCondition.dbRedisName" style="width: 100%"></a-input>
            </star-condition-cell>
            <star-condition-cell label="数据库地址">
                <a-input v-model="searchCondition.dbRedisHost" style="width: 100%"></a-input>
            </star-condition-cell>
            <star-condition-cell label="状态">
                <a-select allowClear v-model="searchCondition.dbRedisStatus" style="width: 100%">
                    <a-select-option :value="1">运行中</a-select-option>
                    <a-select-option :value="-1">已停用</a-select-option>
                    <a-select-option :value="0">未启用</a-select-option>
                </a-select>
            </star-condition-cell>
            <star-condition-cell label="地区">
                <a-select allowClear v-model="searchCondition.dbRedisArea" style="width: 100%">
                    <a-select-option :value="0">国内</a-select-option>
                    <a-select-option :value="1">新加坡</a-select-option>
                </a-select>
            </star-condition-cell>
        </star-condition-layout>

        <div class="table-container">
            <TableHeadIcons :onRefresh="handleSearch" :size.sync="tableDensity" :columns="columns">
                <a-button type="primary" @click="isShowCreateModal = true">
                    <a-icon type="plus"></a-icon>
                    新建
                </a-button>
            </TableHeadIcons>

            <a-table
                    :size="tableDensity"
                    :loading="loading"
                    :pagination="pagination"
                    @change="handleTableChange"
                    rowKey="dbRedisId"
                    :columns="showColumns"
                    :data-source="tableData"
            >
                <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

                <span slot="dbRedisStatus" slot-scope="text, record">
          <a-badge v-if="record.dbRedisStatus === 1" color="blue" text="运行中"> </a-badge>
          <a-badge
                  v-if="record.dbRedisStatus === -1"
                  color="rgba(0,0,0,0.4)"
                  text="已停用"
          ></a-badge>
          <a-badge v-if="record.dbRedisStatus === 0" color="gold" text="未启用"></a-badge>
        </span>

                <span slot="dbRedisArea" slot-scope="text, record">{{
          record.dbRedisArea === 0
            ? '国内'
            : record.dbRedisArea === 1
            ? '新加坡'
            : record.dbRedisArea
        }}</span>

                <span slot="action" slot-scope="text, record">
          <a-button type="link" v-if="record.dbRedisStatus === 1" @click="onClose(record)"
          >停用</a-button
          >
          <a-button type="link" v-if="record.dbRedisStatus === 0" @click="onOpen(record)"
          >启用</a-button
          >
          <a-button type="link" v-if="record.dbRedisStatus === -1" @click="onOpen(record)"
          >重启</a-button
          >

          <a-divider type="vertical"/>
          <a-button type="link" @click="showModifyImageModal(record)">编辑</a-button>
          <a-divider type="vertical"/>
          <a-popconfirm title="确定要删除吗?" @confirm="() => onDeleteDatabase(record)">
            <a-button type="link">删除</a-button>
          </a-popconfirm>
        </span>
            </a-table>
        </div>

        <a-modal v-model="isShowCreateModal" title="新建数据库" @cancel="handleCancel" @ok="onSubmitNewDataBase">
            <a-form-model
                    ref="ruleForm"
                    :model="newDataBase"
                    :rules="rules"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 17 }"
            >
                <a-form-model-item ref="dbRedisName" label="数据库名称" prop="dbRedisName">
                    <a-input v-model="newDataBase.dbRedisName"/>
                </a-form-model-item>

                <a-form-model-item ref="dbRedisHost" label="数据库地址" prop="dbRedisHost">
                    <a-input v-model="newDataBase.dbRedisHost"/>
                </a-form-model-item>

                <a-form-model-item ref="dbRedisPort" label="数据库端口号" prop="dbRedisPort">
                    <a-input-number :min="0" :max="65535" v-model="newDataBase.dbRedisPort"/>
                </a-form-model-item>

                <a-form-model-item ref="dbRedisDb" label="具体库id" prop="dbRedisDb">
                    <a-input-number :min="0" :max="15" v-model="newDataBase.dbRedisDb" style="width: 100%"/>
                </a-form-model-item>

                <a-form-model-item ref="dbRedisPassword" label="密码" prop="dbRedisPassword">
                    <a-input-password v-model="newDataBase.dbRedisPassword"/>
                </a-form-model-item>

                <a-form-model-item ref="dbRedisArea" label="地区" prop="dbRedisArea">
                    <a-select v-model="newDataBase.dbRedisArea">
                        <a-select-option :value="0">国内</a-select-option>
                        <a-select-option :value="1">新加坡</a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-form-model>
        </a-modal>

        <a-modal v-model="isShowModifyModal" title="修改数据库" @ok="onSubmitModifyDatabase">
            <a-form-model
                    ref="ruleFormModify"
                    :model="modifyDataBase"
                    :rules="rules"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 17 }"
            >
                <a-form-model-item ref="dbRedisName" label="数据库名称" prop="dbRedisName">
                    <a-input v-model="modifyDataBase.dbRedisName"/>
                </a-form-model-item>

                <a-form-model-item ref="dbRedisHost" label="数据库地址" prop="dbRedisHost">
                    <a-input v-model="modifyDataBase.dbRedisHost"/>
                </a-form-model-item>

                <a-form-model-item ref="dbRedisPort" label="数据库端口号" prop="dbRedisPort">
                    <a-input-number :min="0" :max="65535" v-model="modifyDataBase.dbRedisPort"/>
                </a-form-model-item>

                <a-form-model-item ref="dbRedisDb" label="具体库id" prop="dbRedisDb">
                    <a-input-number
                            :min="0"
                            :max="15"
                            v-model="modifyDataBase.dbRedisDb"
                            style="width: 100%"
                    />
                </a-form-model-item>

                <a-form-model-item ref="dbRedisPassword" label="密码" prop="dbRedisPassword">
                    <a-input-password v-model="modifyDataBase.dbRedisPassword"/>
                </a-form-model-item>

                <a-form-model-item ref="dbRedisArea" label="地区" prop="dbRedisArea">
                    <a-select v-model="modifyDataBase.dbRedisArea">
                        <a-select-option :value="0">国内</a-select-option>
                        <a-select-option :value="1">新加坡</a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-form-model>
        </a-modal>

        <a-modal
                v-model="isShowSelectNewDatabaseModal"
                title="数据库替换"
                @ok="onChangeDatabase"
                :confirm-loading="modalSubmitloading"
        >
            <p>选择替换的数据库:</p>

            <a-select v-model="willOpenDatabaseId" style="width: 100%">
                <a-select-option
                        v-for="item in notOpenDatabaseList"
                        :key="item.dbRedisId"
                        :value="item.dbRedisId"
                >{{ item.dbRedisName }}
                </a-select-option>
            </a-select>
        </a-modal>
    </div>
</template>

<script>
  import {
    getDatabaseListApi,
    getAllDatabaseNotOpenListApi,
    createDatabaseApi,
    modifyDatabaseApi,
    modifyDatabaseStatusApi,
    deleteDatabaseApi
  } from '@/api/System/Database'
  import { onHttpResponse, onHttpResponseSilent } from '@/utils/request'
  import TableHeadIcons from '@/components/TableHeadIcons'
  import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'

  export default {
    components: { TableHeadIcons },
    mixins: [tableSettingToStoreMixin()],

    data() {
      return {
        searchCondition: {
          dbRedisName: '',
          dbRedisHost: '',
          dbRedisStatus: '',
          dbRedisArea: ''
        },

        spiderClassOptions: [],
        tableData: [],
        columns: [
          {
            width: 60,
            title: '序号',
            align: 'center',
            show: true,
            slots: { title: 'indexTitle' },
            scopedSlots: { customRender: 'index' }
          },
          {
            title: '数据库名称',
            dataIndex: 'dbRedisName',
            show: true
          },
          {
            title: '地址',
            dataIndex: 'dbRedisHost',
            show: true
          },
          {
            title: '端口',
            dataIndex: 'dbRedisPort',
            align: 'center',
            width: 80,
            show: true
          },
          {
            title: '具体库id',
            dataIndex: 'dbRedisDb',
            show: true
          },
          {
            title: '密码',
            dataIndex: 'dbRedisPassword',
            width: 100,
            show: false
          },
          {
            title: '应用区域',
            dataIndex: 'dbRedisArea',
            show: true,
            scopedSlots: { customRender: 'dbRedisArea' }
          },
          {
            title: '状态',
            dataIndex: 'dbRedisStatus',
            align: 'center',
            show: true,
            width: 80,
            scopedSlots: { customRender: 'dbRedisStatus' }
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
            width: 170,
            show: true
          },
          {
            title: '最近启用时间',
            dataIndex: 'openTime',
            show: true,
            width: 170
          },
          {
            title: '停用时间',
            dataIndex: 'closeTime',
            show: false,
            width: 170
          },
          {
            title: '操作',
            key: 'action',
            show: true,
            scopedSlots: { customRender: 'action' },
            width: 180,
            align: 'center'
          }
        ],
        pagination: {
          current: 1,
          pageSize: 10,
          showTotal: (total) => `共 ${total} 条`,
          showSizeChanger: true,
          showQuickJumper: true,
          total: 0,
          size: 'default'
        },
        loading: false,
        tableDensity: 'middle',
        isShowColFilterOverlay: false,

        isShowCreateModal: false,
        newDataBase: {
          dbRedisName: '',
          dbRedisHost: '',
          dbRedisPort: '',
          dbRedisDb: '',
          dbRedisPassword: '',
          dbRedisArea: 0
        },

        isShowModifyModal: false,
        modifyDataBase: {},

        rules: {
          dbRedisName: { required: true, message: '数据库名为必填项', trigger: 'blur' },
          dbRedisHost: { required: true, message: '地址为必填项', trigger: 'blur' },
          dbRedisPort: { required: true, message: '端口号为必填项', trigger: 'blur' },
          dbRedisDb: { required: true, message: '具体库id为必填项', trigger: 'blur' },
          dbRedisPassword: { required: true, message: '密码为必填项', trigger: 'blur' },
          dbRedisArea: { required: true, message: '地区为必选项', trigger: 'blur' }
        },

        notOpenDatabaseList: [],

        isShowSelectNewDatabaseModal: false,
        willCloseDatabaseId: 0,
        willOpenDatabaseId: '',

        modalSubmitloading: false
      }
    },
    computed: {
      showColumns() {
        return this.columns.filter((item) => item.show)
      }
    },
    mounted() {
      this.handleSearch()
    },
    methods: {
      handleSearch() {
        this.pagination.current = 1
        this.getDatabaseList()
      },

      reset() {
        this.searchCondition = {
          dbRedisName: '',
          dbRedisHost: '',
          dbRedisStatus: '',
          dbRedisArea: ''
        }
        this.handleSearch()
      },

      onTableDensityChange(density) {
        this.tableDensity = density
      },

      handleTableChange(pagination) {
        this.pagination = pagination
        this.getDatabaseList()
      },

      getDatabaseList() {
        let query = {
          pn: this.pagination.current,
          pageSize: this.pagination.pageSize,
          ...this.searchCondition
        }
        this.loading = true
        getDatabaseListApi(query)
          .then(onHttpResponseSilent)
          .then((res) => {
            let { code, msg, data, extra } = res
            if (code === 200) {
              this.tableData = data
              this.pagination.total = extra.page.pageCount || 0
            } else {
              this.$message.error(msg)
            }
          })
          .finally(() => {
            this.loading = false
          })
      },

      getClassNameById(record) {
        return (
          this.spiderClassOptions.filter((o) => o.spiderClassId === record.spiderClassId)[0]
            ?.spiderClassName || '未知'
        )
      },
      handleCancel() {
        this.$refs.ruleForm.resetFields()
      },
      onSubmitNewDataBase() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            createDatabaseApi(this.newDataBase)
              .then(onHttpResponse)
              .then(() => {
                this.newDataBase = {
                  dbRedisName: '',
                  dbRedisHost: '',
                  dbRedisPort: '',
                  dbRedisDb: '',
                  dbRedisPassword: '',
                  dbRedisArea: 0
                }
                this.isShowCreateModal = false
                this.handleSearch()
              })
              .catch(() => {
              })
          }

          return valid
        })
      },

      showModifyImageModal(record) {
        if (record.dbRedisStatus === 1) {
          this.$warning({
            title: '运行中的镜像不可编辑',
            content: ''
          })
          return
        }
        this.modifyDataBase = {
          ...record
        }
        this.isShowModifyModal = true
      },

      onSubmitModifyDatabase() {
        this.$refs.ruleFormModify.validate((valid) => {
          if (valid) {
            modifyDatabaseApi(this.modifyDataBase).then((res) => {
              if (res.code === 200) {
                this.$message.success('修改成功')
                this.isShowModifyModal = false
                this.getDatabaseList()
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
          }

          return valid
        })
      },

      onDeleteDatabase(record) {
        if (record.dbRedisStatus === 1) {
          this.$warning({
            content: '运行中的数据库不可删除'
          })
          return
        }

        this.$confirm({
          content: '数据库删除将无法恢复，是否确认删除？',
          onOk: () => {
            return deleteDatabaseApi({ dbRedisId: record.dbRedisId })
              .then(onHttpResponse)
              .then(() => {
                this.getDatabaseList()
                return
              })
              .catch(() => {
              })
          }
        })
      },

      onClose(record) {
        getAllDatabaseNotOpenListApi({ dbRedisArea: record.dbRedisArea })
          .then(onHttpResponseSilent)
          .then((res) => {
            this.notOpenDatabaseList = res.data.filter((d) => d.dbRedisId !== record.dbRedisId)
            if (this.notOpenDatabaseList.length === 0) {
              this.$warning({
                content: '当前无可替代的数据库，不可停用，请新增该站点类型的数据库！'
              })
              return
            }
            this.willCloseDatabaseId = record.dbRedisId
            this.willOpenDatabaseId = ''
            this.isShowSelectNewDatabaseModal = true
          })
          .catch(() => {
          })
      },

      onOpen(record) {
        this.$confirm({
          title: '确认开启',
          content:
            '同一区域类型只可运行一个数据库版本，若启用该版本，则正在运行的数据库版本将自动停用，是否确认启用？',
          onOk: () => {
            return modifyDatabaseStatusApi({ dbRedisId: record.dbRedisId, dbRedisStatus: 1 })
              .then(onHttpResponse)
              .then(() => {
                this.getDatabaseList()
                return
              })
              .catch(() => {
              })
          }
        })
      },

      onChangeDatabase() {
        if (!this.willOpenDatabaseId) {
          this.$message.warn('请选择替换的数据库')
          return
        }
        this.modalSubmitloading = true

        modifyDatabaseStatusApi({
          dbRedisId: this.willCloseDatabaseId,
          dbRedisStatus: -1,
          newDbRedisId: this.willOpenDatabaseId
        })
          .then(onHttpResponse)
          .then(() => {
            this.getDatabaseList()
            this.isShowSelectNewDatabaseModal = false
            return
          })
          .catch(() => {
          })
          .finally(() => {
            this.modalSubmitloading = false
          })
      }
    }
  }
</script>
<style lang="less" scoped>
    .basic-image-container {
        width: 100%;
        padding: 16px;

        .table-container {
            background-color: white;
            padding: 0 16px;
            margin-top: 16px;
        }
    }
</style>
